import { Button, message, Popconfirm } from 'antd';
import React, { useCallback, useState } from 'react';
import { getAlgorithmVersions, hideModel, removeVersion, unhideModel } from '../../../lib/api/algorithm-api';
import { Model } from '../../../types';

type Props = {
  model: Model | Partial<Model>;
  fetchModels: (load: boolean) => void;
  algorithmId: number;
};

export const ModelRow = ({ model, fetchModels, algorithmId }: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  const onHide = useCallback(
    async (modelId: number) => {
      await hideModel(modelId);
      fetchModels(false);
    },
    [fetchModels]
  );

  const onUnhide = useCallback(
    async (modelId: number) => {
      await unhideModel(modelId);
      fetchModels(false);
    },
    [fetchModels]
  );

  const onDelete = useCallback(
    async model => {
      //find correct algorithmVersion corresponding to this modelVersion
      //deleting the algorithmVersion also deletes the modelVersion
      const algoVersions = await getAlgorithmVersions(algorithmId);
      const modelNameArray = model.name.split(' ');
      const modelName = modelNameArray[modelNameArray.length - 1];
      const toDelete = algoVersions.find(algoVersion => algoVersion.version === modelName);
      if (toDelete) {
        await removeVersion(toDelete.id);
        fetchModels(false);
      }
    },
    [fetchModels, algorithmId]
  );

  return (
    <div
      key={model.id}
      className="py-2 flex justify-between items-center border-0 border-b border-solid border-gray-200">
      <span className={model.hidden ? 'text-gray-400 ' : ''}>{model.name}</span>
      <div className="flex gap-3">
        <Button
          className="w-20"
          onClick={() => {
            if (model.id) {
              if (model.hidden) {
                onUnhide(model.id);
              } else {
                onHide(model.id);
              }
            }
          }}>
          {model.hidden ? 'Unhide' : 'Hide'}
        </Button>
        <Popconfirm
          visible={open}
          title="Delete model?"
          onConfirm={() => {
            onDelete(model);
            setOpen(false);
          }}
          onCancel={() => {
            setOpen(false);
          }}>
          <Button
            onClick={() => {
              if (model.hidden) {
                setOpen(true);
              } else {
                message.warning('Please hide this model before deleting it.');
              }
            }}>
            Delete
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
};
